"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  none: 'none',
  sm: '0 2px 4px -1px rgba(5, 28, 44, 0.2), 0 0 1px 0 rgba(5, 28, 44, 0.15)',
  rg: '0 4px 8px -1px rgba(5, 28, 44, 0.2), 0 0 1px 0 rgba(5, 28, 44, 0.15)',
  lg: '0 8px 16px -1px rgba(5, 28, 44, 0.2), 0 0 1px 0 rgba(5, 28, 44, 0.15)',
  xl: '0 16px 32px -1px rgba(5, 28, 44, 0.2), 0 0 1px 0 rgba(5, 28, 44, 0.15)'
};